import { ConditionalOperator } from '@ispm/shared/constants/conditional-operator.enum';
import { ISortConfig } from '@ispm/therapies/interfaces/view-configuration.interface';

export enum RESOURCE_TYPE_NAME {
  TRIALS = 'trials',
  THERAPIES = 'therapies',
  UNCHARACTERIZED_THERAPIES = 'uncharacterizedTherapies',
  TREATMENTS = 'treatments',
  CLINICAL_TRIAL_RECOMMENDATIONS = 'clinicaltrialrecommendations',
  CLINICAL_RECOMMENDATIONS = 'clinicalrecommendations',
  OPINION = 'opinion',
  REVIEWS = 'reviews',
  ANY_RESOURCES = 'anyResources',
}

export const DEFAULT_CLINICALRECOMMENDATION_GROUP_SORT_CONFIG: ISortConfig[] = [
  {
    'type': 'condition',
    'conditions': [
      {
        'path': '@.subjects[*]._aggregatedChildren | [@[].Aberration, @[].MolecularFinding][]',
        'value': [],
        'operator': ConditionalOperator.NEQ
      }
    ]
  },
  {
    'type': 'count',
    'direction': 'DESC',
    'path': 'clinicalEvidence.ampTierAndLevel',
    'value': 'IA'
  },
  {
    'type': 'count',
    'direction': 'DESC',
    'path': 'clinicalEvidence.ampTierAndLevel',
    'value': 'IB'
  },
  {
    'type': 'count',
    'direction': 'DESC',
    'path': 'clinicalEvidence.ampTierAndLevel',
    'value': 'IC'
  },
  {
    'type': 'count',
    'direction': 'DESC',
    'path': 'clinicalEvidence.ampTierAndLevel',
    'value': 'IIC'
  },
  {
    'type': 'count',
    'direction': 'DESC',
    'path': 'clinicalEvidence.ampTierAndLevel',
    'value': 'UNMATCHED'
  }
];
